import type { RxCUI } from '../../types/gateClassification';

export const HIGH_RISK_MEDICATION_CLASSES: Record<string, Set<RxCUI>> = {
  anticoagulants: new Set(['11289', '67108', '69749', '73137', '1364430', '1037042', '1992427']),
  immunosuppressants: new Set(['3008', '42316', '68149', '1256', '35302', '141704']),
  cardiac_drugs: new Set(['3407', '596', '33738', '36437', '69120']),
  insulin_and_analogs: new Set(['5856', '274783', '86009', '325072']),
  chemotherapy: new Set(['6851', '3002', '3639', '2555', '4492']),
  maois: new Set(['8123', '10734', '5764', '9639']),
  lithium: new Set(['6448']),
  antiepileptics: new Set(['8183', '2002', '11118', '8109', '28439']),
  GLP1_AGONIST: new Set(['1991302', '2601723', '475968', '1551291']),
};

export function getAllHighRiskRxCuis(): Set<RxCUI> {
  const all = new Set<RxCUI>();
  for (const rxCuis of Object.values(HIGH_RISK_MEDICATION_CLASSES)) {
    for (const cui of rxCuis) {
      all.add(cui);
    }
  }
  return all;
}

export function getDrugClassForRxCui(rxCui: RxCUI): string | null {
  for (const [drugClass, rxCuis] of Object.entries(HIGH_RISK_MEDICATION_CLASSES)) {
    if (rxCuis.has(rxCui)) {
      return drugClass;
    }
  }
  return null;
}
